"use client";

import Link from "next/link";
import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { Globals } from "@/app/vars/Globals";
import styles from "./ArticleBody.module.css";

type Props = {
  lang: string;
  linkPath: string;
  linkLabel: string;
};

export default function ArticleCalloutAction(props: Props) {
  const { lang, linkPath, linkLabel } = props;
  const T = useT();

  if (Globals.WAITLIST_ENABLED) {
    return (
      <Button
        min={false}
        params={{ lang }}
        text={T(TKey.HOME_WAITLIST_CTA)}
        isLink={false}
        type={ButtonType.PRIMARY}
        onClick={() => ModalStore.getState().openWaitlist({ lang })}
      />
    );
  }

  return (
    <Link href={`/${lang}${linkPath}`} className={styles.calloutLink}>
      {linkLabel}
      <span className={styles.calloutArrow}>→</span>
    </Link>
  );
}
